import React from 'react';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import { getDUIPlacement, getDUIAlignment } from './tooltip-config.js';

/**
 * 自动调整位置,不超出屏幕范围的tooltip
 * @public
 */
class PositionedTooltip extends React.Component {
    constructor(props) {
        var _a, _b, _c, _d;
        super(props);
        this.state = {
            placement: getDUIPlacement((_a = this.props.placement) !== null && _a !== void 0 ? _a : 'left'),
            alignment: getDUIAlignment((_b = this.props.alignment) !== null && _b !== void 0 ? _b : 'center'),
        };
        this.safeWidth = (_c = props.safeWidth) !== null && _c !== void 0 ? _c : 200;
        this.safeHeight = (_d = props.safeHeight) !== null && _d !== void 0 ? _d : 0;
    }
    adjustStartPreferOffsetY() {
        var _a;
        const menuItemDom = (_a = this.tooltipRef) === null || _a === void 0 ? void 0 : _a.rootRef.current;
        if (!menuItemDom) {
            return;
        }
        const menuRectObject = menuItemDom.getBoundingClientRect();
        const menuToViewBottom = menuRectObject.bottom;
        const pageClientHeight = document.documentElement.clientHeight;
        if (menuToViewBottom > pageClientHeight) {
            this.setState({
                offsetY: 0,
                alignment: 'end',
            });
        }
        else if (menuToViewBottom + this.safeHeight > pageClientHeight) {
            this.setState({
                offsetY: pageClientHeight - (menuToViewBottom + this.safeHeight),
            });
        }
        else {
            this.setState({
                offsetY: 0,
            });
        }
    }
    adjustEndPreferOffsetY() {
        var _a;
        const menuItemDom = (_a = this.tooltipRef) === null || _a === void 0 ? void 0 : _a.rootRef.current;
        if (!menuItemDom) {
            return;
        }
        const menuRectObject = menuItemDom.getBoundingClientRect();
        const menuToViewTop = menuRectObject.top;
        if (menuToViewTop < this.safeHeight) {
            this.setState({
                offsetY: this.safeHeight - menuToViewTop,
            });
        }
        else {
            this.setState({
                offsetY: 0,
            });
        }
    }
    adjustPosition() {
        window.requestAnimationFrame(() => {
            if (this.state.placement === 'left' || this.state.placement === 'right') {
                if (this.props.alignment === 'start-prefer') {
                    this.adjustStartPreferOffsetY();
                }
                if (this.props.alignment === 'end-prefer') {
                    this.adjustEndPreferOffsetY();
                }
            }
        });
    }
    componentDidUpdate() {
        this.adjustPosition();
    }
    componentDidMount() {
        this.adjustPosition();
    }
    render() {
        var _a;
        return React.createElement(Tooltip, Object.assign({ className: "main-menu-dropdown-tooltip", ref: tooltipRef => this.tooltipRef = tooltipRef }, this.props, { containerOffsetY: (_a = this.state.offsetY) !== null && _a !== void 0 ? _a : 0, placement: this.state.placement, alignment: this.state.alignment }));
    }
}

export { PositionedTooltip };
//# sourceMappingURL=auto-positioned-tooltip.js.map
